module.exports = __webpack_public_path__ + "img/新闻中心.e2cdf6a0.jpg";